// extracted by mini-css-extract-plugin
export default {"wrapper":"WPContent_wrapper__okCb9","overlay-menu__fade-in-animation":"WPContent_overlay-menu__fade-in-animation__Ttk+X"};